// extracted by mini-css-extract-plugin
export default {"products":"iu-z","card":"ju-z","oosMessaging":"ku-z"};